import { Component, TemplateRef, inject, viewChild } from '@angular/core';

import { CoreService } from '../../../../core/core.service';
import { ModalService } from '../../../../core/services/modal.service';

@Component({
    selector: 'app-ratings',
    templateUrl: './ratings.component.html',
    styleUrls: ['./ratings.component.scss'],
    standalone: false
})
export class RatingsComponent {
    private modalService = inject(ModalService);
    coreService = inject(CoreService);

    public readonly customerratingsModal = viewChild<TemplateRef<any>>('customerratingsModal');

    public openCustomerratingsModal() {
        this.modalService.openModal(this.customerratingsModal(), { centered: true, backdrop: 'static', size: 'lg' });
    }
}
